const { server_ip }= require('../config');

export async function insertRegistration(data){
    try {
        const response= await fetch(`${server_ip}/api/registrations`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function fetchRegistrations(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/registrations/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function approveRegistration(token,id){
    try {
        const response= await fetch(`${server_ip}/api/registrations/approve/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function rejectRegistration(token,id){
    try {
        const response= await fetch(`${server_ip}/api/registrations/reject/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function resetPasswordAndSendEmail(token,email){
    try {
        const response= await fetch(`${server_ip}/api/registrations/resend/onboard-email`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                email
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}